import store from '@/store';
import Utils from '@/utils';
import States from '@/plugins/states';
import { Method, PaymentMethod } from 'easyjs/lib/Schema/Payment';
import Order, { OrderOrigin } from 'easyjs/lib/Schema/Order';
import { TYPE as GiftType } from 'easyjs/lib/Schema/Gift';

export default class {
    _Header = {};
    _Payment = {};
    _Delivery = {};
	_Products = {};
	_Order = {};
	_Origin = null;

    _Observation = null;
    _Width = 41;
    _PadLeft = 28;
    _PadRight = 13;
	_WidthDiff = 6;
	_Format = 80;

	_Blocks = {};
	_Printer = {};
	_Trigger = '';

    constructor (data, format, layout = null, trigger) {
        if (format == '80') {
			this._Format = 80;
            this._PadLeft = 28
            this._PadRight = 13
            this._Width = 41
        } else {
			this._Format = 56;
            this._PadLeft = 17
            this._PadRight = 10
            this._Width = 27
		}
		
		this._Order = data;
	
		this._Trigger = trigger;

        /** set header data */
        let payers = []
        let payersPayment = []
        
        for (const payer of data.payment.payers) {
			payers.push({
                name: payer.user && payer.user.name ? payer.user.name : '',
                phone: payer.user && payer.user.phone ? payer.user.phone : ''
            })
			
            payersPayment.push({
				name: payer.user && payer.user.name ? payer.user.name : '',
                amount: payer.amount,
                method: payer.method,
                changeFor: payer.changeFor,
                paymentMethod: payer.paymentMethod
            })
		}
		
        let environment = '';
        if (store.state.store && store.state.store.configurations && store.state.store.configurations.basic_info && store.state.store.configurations.basic_info.name) {
			environment = store.state.store.configurations.basic_info.name;
        }
		
		this._Header = {
			environment: environment,
            date: data.created_at,
            orderNumber: data.order_id,
            payers: payers
        }
		
        /** set position */
        this._Position = data.position;
		
        /** set products data */
        this._Products = {
			total: data.cart.total,
            items: data.cart.catalog.items
		}
		
        /** set Observation */
        if (data.observation) {
			this._Observation = data.observation
        }
        
		/** set origin */
		this._Origin = this.getOrigin(data.origin);
		
        /** set payment data */
        this._Payment = {
			total: data.payment.total,
            payers: payersPayment
        }
		
        /** set delivery data */
        if (data.delivery.type == 1) {
			this._Delivery = {
				address: data.delivery.address,
                price: data.delivery.price,
                total: data.delivery.total
            }
        }
		
        /** set gift data */
        this._Gift = data.gift;
		
        /** configurações layout */
        if (!layout) {
			layout = {
                blocks: {
					address: true,
                    customer: true,
                    footer: true,
                    header: true,
                    payment: true,
                    products: true,
                    productsValue: true
                }
            }
		}
		
		this._Printer = layout;
        this._Blocks = layout.blocks
    }
	
    _getPaymentMethod(oPayer) {
        let pM = oPayer.paymentMethod
        let pMString = '';
        
        if((pM & PaymentMethod.CREDIT) == PaymentMethod.CREDIT) {
            pMString = StringLanguage.credit
        } else if((pM & PaymentMethod.DEBIT) == PaymentMethod.DEBIT) {
            pMString = StringLanguage.debit
        } else if((pM & PaymentMethod.VOUCHER) == PaymentMethod.VOUCHER) {
            pMString = StringLanguage.voucher
        } else if((pM & PaymentMethod.MONEY) == PaymentMethod.MONEY) {
            pMString = StringLanguage.money
        }

        if((pM & PaymentMethod.ONLINE) == PaymentMethod.ONLINE) {
            pMString += StringLanguage.online
        }

        return pMString
	}
	
	getOrigin(origin) {
		let stringOrigin = "";

		switch(origin) {
			case OrderOrigin.APP: 
				stringOrigin = 'LOJA ONLINE';
				break;
				
			// case OrderOrigin.DESK:
			// 	stringOrigin = 'Gestão';
			// 	break;
				
			case OrderOrigin.PHONE:
				stringOrigin = 'Telefone';
				break;
				
			default:
				stringOrigin = 'Balcão';
				break;
		}

		return stringOrigin;
	}

	getPrintTypeByTrigger() {
		if (this._Trigger == 'whenEditingOrders') {
			return "EDIÇÃO DE PEDIDO";
		} else if (this._Trigger == 'whenCancelingOrders') {
			return "CANCELAMENTO DE PEDIDO";
		} 

		return "";
	}

    wordwrap( str, width, cut ) {
        width = width || 75;
        cut = cut || false;
     
        if (!str) { return str; }
     
        var regex = '.{1,' + width + '}(\s|$)' + (cut ? '|.{' + width + '}|.+$' : '|\S+?(\s|$)');

        return str.match( RegExp(regex, 'g') );     
    }

    normalizeText = (text) => {
        if (!text) return text;
        
        const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ';
        const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';
        const p = new RegExp(a.split('').join('|'), 'g');
		
		return text.toString()
					.toLowerCase()
          			.replace(p, c => b.charAt(a.indexOf(c)));
    }    

    center() {
        return '<<center>>';
    }

    left() {
        return '<<left>>';
    }

    right() {
        return '<<right>>';
    }

    delimiter(str) {
        return str.padEnd(this._Width, str) + this.bl();
    }

    bl() {
        return '<<bl>>';
    }

    feed(value) {
        return '<<feed>>' + String.fromCharCode(value);
    }

    cut() {
        return '<<cut>>';
    }

    price (value, qty = 1) {
		if (value) {
			value = parseFloat(value) * qty;

			value = value.toLocaleString('pt-BR').split(',');
			
			const length =  value.length;
	
			
			if (length > 1) {
				const cents = value[length - 1];
				value[length - 1] = cents.toString().padEnd(2, '0');
				
				value = value.join(',');
			} else {
				value = `${value[0]},00`;
			}	
			
	
			return `R$${value}`;
		}
       
		return ' ';
    }

    setLeftSpace (value, n = 0) {
        n = n + value.length
        return value.padStart(n)
    }

	/** 
		* @description Adicionar linha
    	* @param {String} value1 Primeiro valor da linha
    	* @param {String} label Label
    	* @param {String} value2 Segundo valor da linha
    	* @param {Boolean} breakLeft Se haverá quebra de linha
		* @returns {String}
	*/
    line(value1, label = false, value2 = null, breakLeft = false, widthGift = false) {
        value1 = this.normalizeText(value1);
        let layout = [];
		let value = '';
		let _WidthGift = this._Width + 2;
		
        label = label ? `${String(label).toUpperCase()}: ` : '';
        value = label + String(value1).toUpperCase();

        const sizeBreak = breakLeft ? this._PadLeft : parseInt(this._PadLeft) + parseInt(this._PadRight);
		const valueBreak = this.wordwrap(value, sizeBreak, 'n', true);
		
        if (value2) {
			value = `${valueBreak[0]}${value2.trim().padStart((widthGift ? _WidthGift : this._Width  ) - valueBreak[0].length).toUpperCase()}`;
            valueBreak[0] = value;
        }

        for (const v of valueBreak) {
			if (valueBreak.length > 1 && v.length < this._Width) {
				v = v.padEnd(this._Width);
			}

            layout.push(`${v}${this.bl()}`);
        }
    
        return layout;
	}
	
	/** 
	 * @description Gera o layout teste que vai ser impresso no primeiro passo da criação da impressora
	*/
	generateTestLayout() {
		let layout = [];

		// Header
        layout.push(this.center());
        layout = layout.concat(this.line(this._Header.environment));
        layout.push(this.left());
		layout.push(this.bl());
		
		// Área de teste
		layout.push(this.center());
		layout.push(this.delimiter('*'));
		layout = layout.concat(this.line('** TESTE DE IMPRESSÃO **'));
		layout.push(this.delimiter('*'));
		
		// Mensagem de finalizado
		layout = layout.concat(this.bl());
		layout.push(this.center());
		layout = layout.concat(this.line('TESTE REALIZADO COM'));
		layout.push(this.center());
		layout = layout.concat(this.line('SUCESSO!'));

		// Adicionando quebra de linha no fim da impressão
		for (let i = 0; i < 7; i++) {
			layout = layout.concat(this.bl());
		}
		
		layout = layout.concat(this.cut());

		return layout;
    }
    
	/** 
	 * @description Gera um layout teste fixo mostrando como a impressão final ficará
	 * e o que vai ser impresso no segundo passo da criação da impressora
	*/
    generateFixedLayout() {
		let layout = [];

		const padStartString = (this._Format == 80) ? '' : ''.padStart(7, ' ');

		// Nome da Loja
		layout.push(this.center());
		layout = layout.concat(this.line('NOME DA LOJA'));
        layout.push(this.bl());
        
		// Edição/Cancelamento
		layout.push(this.delimiter('*'));
		layout.push(this.center());
		layout = layout.concat(this.line('EDIÇÃO ou CANCELAMENTO DE PEDIDO'));
        layout.push(this.delimiter('*'));
        layout.push(this.bl());

		// Conteúdo Cabeçalho
		layout.push(this.delimiter('-'));
		layout.push(this.center());
		layout = layout.concat(this.line('CONTEÚDO CABEÇALHO'));
		layout.push(this.delimiter('-'));
        
		// Dados
		layout.push(this.bl());
		layout = layout.concat(this.line('01/01/2020 - 12:00', null, ' '));
		layout = layout.concat(this.line('PEDIDO: 83', null, ' '));
		layout = layout.concat(this.line('SENHA: 5', null, ' '));
		layout = layout.concat(this.line(`CLIENTE: ${this.normalizeText('JOÃO DA SILVA')}`, null, ' '));
		layout = layout.concat(this.line('TELEFONE: 41999999999', null, ' '));
		layout = layout.concat(this.line('ORIGEM: TELEFONE', null, ' '));
        layout.push(this.bl());
        
		// Delimitador de Pedido
		layout.push(this.center());
		layout.push(this.delimiter('-'));
		layout = layout.concat(this.line('PEDIDO'));
        layout.push(this.delimiter('-'));
        
        // Produtos
        layout.push(this.bl());
        layout = layout.concat(this.line('PRODUTO', null, ' '));
        layout = layout.concat(this.line(this.setLeftSpace('1 UN x R$10,00 = '), false, this.price(10)));
        layout.push(this.bl());

		// Totais
		layout.push(this.center());
        layout.push(this.delimiter('-'));
		layout = layout.concat(this.line('SUBTOTAL', null, this.price(10)));
		layout = layout.concat(this.line('TAXA DE ENTREGA', null, this.price(3.5)));
		layout = layout.concat(this.line('DESCONTO', null, this.price(2)));
		layout = layout.concat(this.line('ACRÉSCIMO', null, this.price(1)));
        layout.push(this.delimiter('-'));
        layout = layout.concat(this.line('total do pedido', null, this.price(12.50)));
		layout.push(this.center());
        layout.push(this.delimiter('-'));

        // Pagamento
		layout.push(this.center());
        layout = layout.concat(this.line('** PAGAMENTOS **'));
        layout.push(this.bl());
        layout = layout.concat(this.line('NOME DO CLIENTE', null, ' '));
        layout = layout.concat(this.line(this.setLeftSpace('- MASTERCARD', 2), null, this.price(12.5), true));
        layout.push(this.bl());
        
		// Endereço
		layout.push(this.center());
		layout.push(this.delimiter('-'));
        layout = layout.concat(this.line('** ENDEREÇO DE ENTREGA **'));
        layout.push(this.bl());
		layout.push(this.center());
        layout = layout.concat(this.line('RUA DO CLIENTE, 10'));
		layout.push(this.center());
        layout.push(this.delimiter('-'));
        
		// Conteúdo rodapé
		layout = layout.concat(this.line('CONTEÚDO RODAPÉ'));
        layout.push(this.delimiter('-'));
        
        layout.push(this.center());
        layout = layout.concat(this.line('CUPOM NAO FISCAL'));

		// Adicionando quebra de linha no fim da impressão
		for (let i = 0; i < 7; i++) {
			layout = layout.concat(this.bl());
		}
		
		layout.push(this.cut());
		
		return layout;
}

	async generateLayout(fiscal = false, reprint = false, printer = null, editCancel = false) {
		let layout = [];

		layout = layout.concat(this.getHeader(reprint, printer, editCancel));

		if (this._Blocks.products) {
			// Delimitador de Pedido
			layout.push(this.delimiter('-'));
			layout = this.pushCenterOnlyWhenFormatIs80(layout, 'PEDIDO');
			layout.push(this.delimiter('-'));
		}

		/** generate products */
		if (this._Blocks.products && this._Blocks.productsValue) {
			layout = layout.concat(this.getProducts());
		}

        /** generate subtotal */
		layout = layout.concat(this.getProductSubtotalTotal());

        /** generate payments */
        if (this._Blocks.payment) {
            layout = layout.concat(this.getPayments());
            layout.push(this.delimiter('-'));
        }

        /** generate address */
        if (this._Blocks.address) {
            layout = layout.concat(this.getAddress());
            layout.push(this.delimiter('-'));
		}

		if (this._Blocks.footer) {
			if (printer.footer) {
				layout = this.pushCenterOnlyWhenFormatIs80(layout, `${printer.footer}`);
				layout.push(this.delimiter('-'));	
			}
		}
		
        if (!fiscal) {
			layout = this.pushCenterOnlyWhenFormatIs80(layout, 'CUPOM NÃO FISCAL');
            layout.push(this.left());
		}

		// Adicionando quebra de linha no fim da impressão
		for (let i = 0; i < 7; i++) {
			layout = layout.concat(this.bl());
		}

		layout.push(this.cut());
		
		return layout;
	}

    generatePrintLayout(fiscal = false, reprint = false) {
        // let layout = ['\x1B\x40'] //initialize esc/pos
        let layout = []
        /** generate queue number top */
        if (this._Position) {
            layout = layout.concat(this.getQueueNumber(this._Position))
        }

        /** generate header */
        layout = layout.concat(this.getHeader(reprint))

        /** generate products */
        layout = layout.concat(this.getProducts())

        /** generate subtotal */
        if (this._Blocks.productsValue) {
            layout = layout.concat(this.getProductSubtotalTotal())
        }

        /** generate observation */
        if (this._Observation) {
            layout = layout.concat(this.getObservation(this._Observation, true))
        }

        /** generate payments */
        if (this._Blocks.payment) {
            layout.push(this.delimiter('-'))
            layout = layout.concat(this.getPayments())
            layout.push(this.delimiter('-'))
        } else {
            layout.push(this.delimiter('-'))
        }

        /** generate address */
        if (this._Blocks.address) {
            layout = layout.concat(this.getAddress())
            layout.push(this.delimiter('-'))
        }

        if (!fiscal) {
            layout.push(this.center())
            layout = layout.concat(this.line('cupom nao fiscal'))
            layout.push(this.left())
		}
		
		layout.push(this.bl());
		layout.push(this.bl());
		layout.push(this.bl());
		layout.push(this.bl());

        layout.push(this.cut())

        return layout
    }

    getQueueNumber(queueNumber) {
        let layout = [];
        layout.push(this.delimiter('*'));
        layout.push(this.center());
        layout = layout.concat(this.line(`Sua senha: ${queueNumber}`));
        layout.push(this.left());
        layout.push(this.delimiter('*'));

        return layout
	}
	
	pushCenterOnlyWhenFormatIs80(layout, text) {
		let padStartString = '';

		if (this._Format == 80) {
			layout.push(this.center());
		} else {
			const textLength = text.length;
			const padLength = (27 - textLength) / 2;
			padStartString = ''.padStart(+padLength, ' ');
		}

		layout = layout.concat(padStartString.concat(this.line(text)));

		return layout;
	}

    getHeader(reprint, printer = null, editCancel = false) {
		let layout = [];
		
		/** Título */
		layout = this.pushCenterOnlyWhenFormatIs80(layout, this._Header.environment);
        layout.push(this.bl());
    
        /** se 2a via */
        if (reprint) {
			layout.push(this.delimiter('*'));
			layout = this.pushCenterOnlyWhenFormatIs80(layout, '** 2a via **');
            layout.push(this.delimiter('*'));
		}
		
		const triggerToBePrinted = this.getPrintTypeByTrigger();
    
        /** se estiver editando ou cancelando pedido */
        if (triggerToBePrinted) {
			const text = (editCancel == 'edit') ? 'EDIÇÃO DE PEDIDO' : 'CANCELAMENTO DE PEDIDO';

            layout.push(this.delimiter('*'));
			layout = this.pushCenterOnlyWhenFormatIs80(layout, `** ${triggerToBePrinted} **`);
            layout.push(this.delimiter('*'));
		}
		
		if (this._Blocks && this._Blocks.header) {
			if (printer && printer.header) {
				layout.push(this.delimiter('-'));
				layout = this.pushCenterOnlyWhenFormatIs80(layout, `${printer.header}`);	
				layout.push(this.delimiter('-'));
			}
		}
    
        /** data */
		layout.push(this.bl());
		layout = layout.concat(this.line(Utils.dateParse(this._Header.date), null, ' '));
		layout = layout.concat(this.line(this._Header.orderNumber, 'Pedido', ' '));
		
		if (this._Position) {
			layout = layout.concat(this.line(this._Position.toString(), 'SENHA', ' '));			
		}
				
		if (this._Blocks && this._Blocks.customer) {
			const hasAtLeastOnePayer = this._Header.payers.some((payer) => payer.name);
			if (hasAtLeastOnePayer) {
				const payer = this._Header.payers[0];

				if (payer.name) {
					layout = layout.concat(this.line(payer.name, 'CLIENTE', ' '));
					layout = layout.concat(this.line(Utils.phoneMask(payer.phone), 'telefone', ' '));
				}       
			}			
		}
		
		layout = layout.concat(this.line(this.normalizeText(this._Origin), 'ORIGEM', ' '));
    
        layout.push(this.bl());

        return layout;
    }

    getProducts () {
        let layout = [];
		
		let index = 0;
		
		// Transforma a variável _Order em objeto Order para que possa acessar suas propriedades
		const order = Order.fromObject({ ...this._Order });

		// Com base nas categorias filtradas, recebe somente os itens que deverão ser percorridos
		const filteredItems = order.cart.catalog.items

		// Recebe o tamanho do array para verificar se é necessário adicionar um delimitador final
		const itemsLength = filteredItems.length;		
        for (const item of filteredItems) {
			layout.push(this.bl());

			layout = layout.concat(this.getProductHeaderString(item));
			
			const subItemsLength = item.items.length;
			if (item.type == 'pizza') {
				if (subItemsLength > 0 && this._Blocks.products) {
					item.items.map((internalItem) => {
						let initialString = '';

						switch (true) {
							case subItemsLength == 1:
								initialString = `INTEIRA `;
								break;
							case subItemsLength > 1:
								initialString = `${this.reduceFlavorFraction(internalItem.quantity, this.getFlavorsQuantity(item.items))} `;
								break;
							default:
								break;
						}

						layout = layout.concat(this.line(`${initialString}${internalItem.name}`, null, ' '));
					});				
				} 

				layout.push(this.bl());
			}

			if (item.type == 'step' && this._Blocks.products) {
				item.items.map((item) => {
					layout = layout.concat(this.line(item.name, null, ' '));

					item.items.map(subItem => {
						const subItemInfo = subItem.quantity > 1 ? ` (${subItem.quantity}X)` : '';
						layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(`${subItem.name}${subItemInfo}`, subItem.getPrice()));
					});
					layout.push(this.bl());
				});				
			}

			/** dough */
			if (item.doughs && item.doughs.length > 0) {
				if (this._Blocks.products) {
					layout = layout.concat(this.line('Massa:', null, ' '));
				}
				
				item.doughs.map((dough) => {
					layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(dough.name, dough.getPrice()));
					layout.push(this.bl());
				});
			}
			
			/** extra */
			if (item.extra_ingredients && item.extra_ingredients.length > 0) {
				if (this._Blocks.products) {
					layout = layout.concat(this.line('INGREDIENTE EXTRA:', null, ' '));
				}
				
				item.extra_ingredients.map((extra) => {
					layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(extra.name, extra.getPrice()));
				});
				
				layout.push(this.bl());
			}

			/** edge */
			if (item.edges && item.edges.length > 0) {
				if (this._Blocks.products) {
					layout = layout.concat(this.line('Borda:', null, ' '));
				}
				
				item.edges.map((edge) => {
					layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(edge.name, edge.getPrice()));
					layout.push(this.bl());
				});
			}

			/** observation */
			if (item.observation && this._Blocks.products) {
				layout = layout.concat(this.getObservation(item.observation));
				layout = layout.concat(this.bl());
			}
			
			if ((index + 1) < itemsLength) {
				layout.push(this.delimiter('-'));
			}

			index += 1;
        }
        

        return layout
	}

	getFlavorsQuantity(items){
      return items.reduce((total, flavor) => total + flavor.quantity, 0)
    }

	reduceFlavorFraction(num, den) {
      function gcd(a, b){
          return b ? gcd(b, a % b) : a;
      }
      
      const gcdResult = gcd(num, den);
      return `${num/gcdResult}/${den/gcdResult}`;
    }

	printNameAndValueOnlyIfIsNeeded(itemName, itemPrice, breakLeft = false) {
		let layout = [];

		const printName = (this._Blocks.products) ? itemName : ' ';
		const printValue = (this._Blocks.productsValue) ? this.price(itemPrice) : ' ';

		layout = layout.concat(this.line(printName, null, printValue, breakLeft));

		return layout;
	}
	
	getProductHeaderString(item) {
		let layout = [];

		if (this._Blocks.products) {
			layout = layout.concat(this.line(`${item.categoryName}`, null, ' '));
		}


		if (item.type == 'simple') {
			layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(`[${item.quantity}X] ${item.name}`, item.getPrice(), true));
		} else if (item.type == 'pizza') {
			layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(`[${item.quantity}X] ${item.name}`, item.getPrice(), true));
		} else if (item.type == 'drink') {
			const sizeInfo = item.sizes[0].name.replace(/[()]/g, '');
			layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(`[${item.quantity}X] ${item.name}`, item.getPrice(), true));
			layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(`(${sizeInfo})`, null));
		} else {
			const hasOneSize = (item.sizes ||[]).length == 1; 
			const sizeInfo =  hasOneSize && item.sizes[0].name == 'Tamanho Único' ? '' : `(${item.sizes[0].name})`;
			layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(`[${item.quantity}X] ${item.name}`, item.getPrice(), true));
			if (!!sizeInfo) {
				layout = layout.concat(this.printNameAndValueOnlyIfIsNeeded(`${sizeInfo}`, null));
			}
		}

		layout.push(this.bl());

		return layout;
	}

    getProductSubtotalTotal () {
        let layout = [];
        
        layout.push(this.delimiter('='));

		if (this._Blocks.products) {
			layout = layout.concat(this.line('subtotal', false, this.price(this._Products.total), true));
		
			if (this._Order.origin != OrderOrigin.DESK) {
				// Verifica se é para entrega e se a taxa de entrega é 0 então é grátis
				const isFreeFee = !!(this._Delivery.address && this._Delivery.total == 0);
				
				layout = layout.concat(this.line('taxa de entrega', null, (isFreeFee) ? 'GRATIS' : this.price(this._Delivery.total)));
			}
	
			// Valida se é do tipo desconto
			if (this._Gift && [138, 140].includes(this._Gift.type) && this._Gift.value > 0 && this._Origin !== 'LOJA ONLINE') {
				const discountValue = this._Products.total*(this._Gift.value/100);
				const discountInfo = `(${this._Gift.value}%25) ${this.price(discountValue)}`;
				layout = layout.concat(this.line('desconto', null, discountInfo, null, true));
			}
			
			// Valida se é do tipo acréscimo
			if (this._Gift && [139, 141].includes(this._Gift.type) && this._Gift.value > 0) {
				const additionValue = this._Products.total*(this._Gift.value/100);
				const additionInfo = `(${this._Gift.value}%25) ${this.price(additionValue)}`;
				layout = layout.concat(this.line('acréscimo', null, additionInfo, null, true));
			}
			
			const order = Order.fromObject({ ...this._Order });

			// Validar se é um coupom
			if (this._Gift && this._Origin === 'LOJA ONLINE' && order.gift) {
				if (order.gift && order.gift.typeIs(GiftType.DELIVERY)) {
					const cupomInfo = `(${this._Gift.value}%25) -${this.price(this._Delivery.total)}`;
					layout = layout.concat(this.line(`Cupom aplicado(${this._Gift.code})`, null, cupomInfo, null, true));
				}
				if (order.gift.typeIs(GiftType.PERCENT) && !order.gift.typeIs(GiftType.DELIVERY)) {
					const cupomValue = this._Products.total*(this._Gift.value/100);
					const cupomInfo = `(${this._Gift.value}%25) -${this.price(cupomValue)}`;
					layout = layout.concat(this.line(`Cupom aplicado(${this._Gift.code})`, null, cupomInfo, null, true));
				}

				if (order.gift.typeIs(GiftType.PRICE)) {
					const cupomInfo = `-${this.price(this._Gift.value)}`;
					layout = layout.concat(this.line(`Cupom aplicado(${this._Gift.code})`, null, cupomInfo, null, false));
				}
			}

			layout.push(this.delimiter('-'));
			layout = layout.concat(this.line('total do pedido', null, this.price(this._Payment.total)));
			layout.push(this.delimiter('='));
		}

        return layout;
    }

    getProductStep (items, n = 2) {
        let layout = []

        for (const step of items) {
            layout = layout.concat(this.getProductSimple(step, n))
            for (const stepItem of step.items) {
                if (this._Blocks.productsValue) {
                    layout = layout.concat(this.line(this.setLeftSpace(`${stepItem.name} (${this.price(stepItem.price)})`, n+2)))
                } else {
                    layout = layout.concat(this.line(this.setLeftSpace(`${stepItem.name}`, n+2)))
                }
            }
        }

        return layout
    }

    getProductPrice (price, qty = 1) {
		let layout = []
		
        if (this._Blocks.productsValue) {
            layout = layout.concat(this.line(this.setLeftSpace(`${qty} un. x ${this.price(price)} =`), false, this.price(price, qty)))
        } else {
            layout = layout.concat(this.line(this.setLeftSpace(`${qty} un. x`)))
        }

		return layout
    }

    getProductSimple (item, n = 0) {
		let layout = []
		
        if (this._Blocks.productsValue) {
            layout = layout.concat(this.line(item.name, false, ' ', true))
        } else {
            layout = layout.concat(this.line(this.setLeftSpace(item.name, n)))
		}
		
        return layout
    }

    getProductItems (name, items, level = 0) {
        let layout = [];
		layout = layout.concat(this.line(`${name}:`));
		
        for (const item of items) {
            let itemDesc = ''
            if (this._Blocks.productsValue) {
                itemDesc = this.setLeftSpace(`${item.name} ${this.price(item.price)}`, level)
            } else {
                itemDesc = this.setLeftSpace(`${item.name}`, level)
            }
            layout = layout.concat(this.line(itemDesc))
        }
        return layout
    }

    getObservation (comment, block = false) {
        let layout = [];

		layout = layout.concat(this.line('Observação:', null, ' '));
		layout = layout.concat(this.line(comment, null, ' '));

        // if (block) {
        //     layout.push(this.delimiter('-'))
        //     layout.push(this.center())
        //     layout = layout.concat(this.line('** Observação **'))
        //     layout.push(this.left())
        //     layout.push(this.delimiter('-'))
        // }

        // if (!block) {
        //     layout = layout.concat(this.line('Comentário:'))
        //     comment = this.setLeftSpace(comment, 2)
        // }

        // layout = layout.concat(this.line(comment))

        return layout;
    }

    getPayments () {
		let layout = []
		layout = this.pushCenterOnlyWhenFormatIs80(layout, '** Pagamentos **');

		this._Payment.payers.map((payer, index) => {
			let hasChangeFor = ''
			let lastPartOfString = '';
			
			// Verifica se o pagamento foi feito em dinheiro
			if ((payer.paymentMethod & PaymentMethod.MONEY) == PaymentMethod.MONEY) {
				if (payer.changeFor > 0) {
					const changeValue = payer.changeFor - payer.amount;
					hasChangeFor = `${this.price(changeValue)} (${this.price(payer.changeFor)})`;
				}
			} else {
				lastPartOfString = `(${Method[payer.method].name})`;
			}

			layout = layout.concat(this.line(`Pagante ${index + 1}`, null, ' '))
			layout = layout.concat(this.line(`- ${this._getPaymentMethod(payer)} ${lastPartOfString}`, null, this.price(payer.amount), true));

			if (!!hasChangeFor) {
				layout = layout.concat(this.line(`- TROCO: ${hasChangeFor}`, null, ' '));
			}
		});
		        
        return layout
    }

    getAddress () {
        let layout = [];
		
        if (this._Delivery && this._Delivery.address) {
			const complementAddress = (this._Delivery.address.complement) ? `(${this._Delivery.address.complement})` : ``;

			layout = this.pushCenterOnlyWhenFormatIs80(layout, '** entregar no endereco **');
            layout = layout.concat(this.line(`${this._Delivery.address.address}, ${this._Delivery.address.number} ${complementAddress}`));
            layout = layout.concat(this.line(`${this._Delivery.address.region} - ${this._Delivery.address.city} - ${States.getShortNameByName(this._Delivery.address.state)}`));
        } else {
			layout = this.pushCenterOnlyWhenFormatIs80(layout, '** Retirada Balcão **');
        }

        return layout
    }
}